import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <path d="M2.5 2v6h6M2.66 15.57a10 10 0 1 0 .57-8.38" />
  </Base>
);
